// src/pages/OrderManagement.tsx
import { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import DashboardTopbar from "../components/DashboardTopbar";

const initialOrders = [
  {
    id: 1,
    customer: "Sarah Thompson",
    items: [
      { name: "Pepperoni Pizza", changes: "Extra cheese" },
      { name: "Garlic Bread" },
    ],
    notes: "Call upon arrival",
    status: "new",
  },
  {
    id: 2,
    customer: "James Lee",
    items: [{ name: "Vegan Burger", changes: "No mayo" }],
    notes: "Allergic to nuts",
    status: "new",
  },
];

const statuses = ["new", "getting_ready", "ready", "driver_on_the_way"];

const OrderManagement = () => {
  const [orders, setOrders] = useState(initialOrders);

  useEffect(() => {
    const interval = setInterval(() => {
      const newId = Math.floor(Math.random() * 1000);
      setOrders((prev) => [
        ...prev,
        {
          id: newId,
          customer: "New Customer",
          items: [{ name: "Sample Item" }],
          notes: "Rush order",
          status: "new",
        },
      ]);
    }, 15000);
    return () => clearInterval(interval);
  }, []);

  const advanceOrder = (id: number) => {
    setOrders((prev) =>
      prev.map((order) => {
        if (order.id === id) {
          const currentIndex = statuses.indexOf(order.status);
          if (currentIndex < statuses.length - 1) {
            return { ...order, status: statuses[currentIndex + 1] };
          }
        }
        return order;
      })
    );
  };

  const declineOrder = (id: number) => {
    setOrders((prev) => prev.filter((order) => order.id !== id));
  };

  return (
    <div className="flex min-h-screen bg-gray-100 text-black">
      <Sidebar />
      <div className="flex flex-col flex-1">
        <DashboardTopbar
          logoUrl="/logo.png"
          name="FullPlateNow Restaurant"
          address="123 Main St, Springfield"
        />
        <main className="p-8">
          <h1 className="text-2xl font-bold mb-4">Order Management</h1>
          <p className="text-sm text-gray-600 mb-6">
            Manage incoming orders and advance them through fulfillment stages.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {statuses.map((status) => (
              <div key={status}>
                <h2 className="text-lg font-semibold mb-3 capitalize">
                  {status.replace(/_/g, " ")}
                </h2>
                <div className="space-y-4">
                  {orders
                    .filter((order) => order.status === status)
                    .map((order) => (
                      <div
                        key={order.id}
                        className="bg-white rounded-xl shadow-sm border border-gray-200 p-4"
                      >
                        <p className="font-semibold text-sm mb-2">
                          {order.customer}
                        </p>
                        <ul className="text-sm text-gray-700 mb-2">
                          {order.items.map((item, i) => (
                            <li key={i}>
                              {item.name}
                              {item.changes && (
                                <span className="text-xs italic text-gray-400">
                                  {" "}
                                  – {item.changes}
                                </span>
                              )}
                            </li>
                          ))}
                        </ul>
                        {order.notes && (
                          <p className="text-xs text-gray-500 italic mb-2">
                            Notes: {order.notes}
                          </p>
                        )}

                        {status === "new" ? (
                          <div className="flex gap-2">
                            <button
                              onClick={() => advanceOrder(order.id)}
                              className="px-3 py-1 text-sm bg-green-600 text-white rounded hover:bg-green-700"
                            >
                              Accept
                            </button>
                            <button
                              onClick={() => declineOrder(order.id)}
                              className="px-3 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
                            >
                              Decline
                            </button>
                          </div>
                        ) : status !== "driver_on_the_way" ? (
                          <button
                            onClick={() => advanceOrder(order.id)}
                            className="px-3 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
                          >
                            Mark as Ready
                          </button>
                        ) : (
                          <p className="text-xs text-green-600 font-medium">
                            Driver en route
                          </p>
                        )}
                      </div>
                    ))}
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default OrderManagement;
